export default __webpack_public_path__ + "static/media/skvllpvnkz-image-placeholder.d47337b0.png";